module.exports = __webpack_public_path__ + "static/media/vorxis-logo.3743bb54.jpg";